import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { DottedHr, DefaultButton, colors } from 'design-system';
import clsx from 'clsx';
import { Typography, makeStyles, Theme } from '@material-ui/core';
import LoginIcon from 'src/components/Icons/LoginIcon';

const useStyles = makeStyles((theme: Theme) => ({
  loginSection: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1, 0),
    margin: theme.spacing(4, 0),
  },
  loginButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  verticalLine: {
    borderLeft: `1px solid ${colors.bright_turquoise}`,
    height: theme.spacing(3.5),
  },
  btnText: {
    color: colors.bright_turquoise,
    fontWeight: 'bold',
  },
  item: {
    margin: theme.spacing(0, 0.75),
  },
}));

const ExecutiveButton = (): JSX.Element => {
  const classes = useStyles();
  const navigate = useNavigate();

  /**
   * Navigates to the login screen
   */
  const onGoToLoginRequested = useCallback((): void => {
    navigate(`/login${window.location.search}`);
  }, [navigate]);

  return (
    <div className={classes.loginSection}>
      <div style={{ width: '85vw' }}>
        <DottedHr />
      </div>
      <DefaultButton
        id="sales-web-inspection-button-collaboratorlogin"
        data-testid="login-btn"
        variant="borderless"
        onClick={onGoToLoginRequested}
      >
        <div className={classes.loginButton}>
          <div className={clsx(classes.item)}>
            <LoginIcon />
          </div>
          <div className={clsx(classes.verticalLine, classes.item)} />
          <Typography
            variant="caption"
            className={clsx(classes.btnText, classes.item)}
            data-testid="executive-button-text"
          >
            EJECUTIVO DE ASSA
          </Typography>
        </div>
      </DefaultButton>
    </div>
  );
};

export default ExecutiveButton;
